<template>
  <div class="client_manage">
   <!-- <a-card title="运费设置" :bordered="false"> -->
      <!-- 搜索 -->
      <div class="search">
        <a-form layout="inline" :form="form" @submit="handleSearch">
			
		  <a-form-item>
			<a-select :allowClear="true" placeholder="请选择模板状态" style="width: 150px" v-decorator="['is_use']">
			    <a-select-option :value="2">未使用</a-select-option>
			    <a-select-option :value="1">已使用</a-select-option>
			</a-select>
		  </a-form-item>
		  <a-form-item>
		  			<a-select :allowClear="true" placeholder="请选择计算方式" style="width: 150px" v-decorator="['type']">
		  			    <a-select-option :value="1">默认</a-select-option>
		  			    <a-select-option :value="2">件数</a-select-option>
		  			    <a-select-option :value="3">重量</a-select-option>
		  			</a-select>
		  </a-form-item>

          <a-form-item>
            <a-input  placeholder="请输入模板名称" v-decorator="['name']"></a-input>
          </a-form-item>

          <a-form-item>
            <a-button @click="handleReset">
              重置
            </a-button>
          </a-form-item>

          <a-form-item>
            <a-button type="primary" html-type="submit">
              查询
            </a-button>
          </a-form-item>

        </a-form>
      </div>

      <!-- 操作栏 -->
      <div class="handle">
        <a-button type="primary" @click="onAddTemplate">添加模版</a-button>
        <a-divider type="vertical" />
        <a-button @click="httpBatchDelete">批量删除</a-button>
      </div>

      <!-- 表格 -->
      <a-table  :columns="columns" :dataSource="list" :rowSelection="{selectedRowKeys: selectedRowKeys, onChange: onSelectChange}" :loading="loading" :pagination="{total:total,onChange:changePage}">
		<span slot="calculate_type" slot-scope="text,record">
			<span v-if="record.type == '1'">默认</span>
			<span v-if="record.type == '2'">件数</span>
			<span v-if="record.type == '3'">重量</span>
		</span>
        <span slot="switch" slot-scope="text,record">
          <a-switch v-model="record.isw" @change="onSwitchChange(record)" />
        </span>

        <span slot="action" slot-scope="text,record">
          <template v-if="record.is_use_str == '未使用'">
            <a-button icon="form" size="small" @click="$router.push({path:'config/edit?id=' + record.id +'&pageType=2'})"> 编辑</a-button>
            <a-divider type="vertical" />
            <a-button icon="delete" size="small" @click="deleteItem(record)">删除</a-button>
          </template>
          <a-button v-else icon="search" size="small" @click="$router.push({ path:'config/view?id=' + record.id +'&pageType=3'})">查看</a-button>


        </span>

      </a-table>
   <!-- </a-card> -->
  </div>
</template>

<script>
const columns = [
  {
    title:'模版名称',
    key:'name',
	align:'center',
    dataIndex:'name'
  },
  {
    title:'计算方式',
    key:'type',
	align:'center',
	align:'center',
    dataIndex:'type',
	scopedSlots: { customRender: 'calculate_type' }
  },
  {
    title:'设为默认',
    key:'type',
	align:'center',
    dataIndex:'is_default',
    scopedSlots: { customRender: 'switch' }
  },
  {
    title:'状态',
    key:'is_use_str',
	align:'center',
    dataIndex:'is_use_str',
  },
  {
    title:'添加时间',
    key:'add_time',
	align:'center',
    dataIndex:'add_time',
  },
  {
    title:'操作',
    key:'action',
	align:'center',
    scopedSlots: { customRender:'action' },
  }
]



export default {
  data(){
    return {
      columns,
      actionlist: {},
      visible: false,
      selectedRowKeys: [],
      list: [],
      form: this.$form.createForm(this, { name: 'configQuery' }),
      loading: true,
      selectall:[],
	  pages: 1,
	  total: 0
    }
  },
  mounted(){
    let result = this.getActionList()
    if(result.length){
      this.actionlist = {...result[0]}
    }
    this.httpInits()
  },
  methods: {
    deleteItem(record){
      this.$confirm({
        title: '提示',
        content: '确认要删除此模版吗？',
        okText: '确认',
        okType: 'danger',
        cancelText: '取消',
        onOk:() => {
          this.httpDeletes(record.id)
          // httpDeletes.call(this,record.id)
        },
        onCancel:() => {

        }
      })
    },
    /**
     * @name 删除订单
     */
    httpDeletes(id){
      this.$request.get('?module=pc_api&action=freight&m=del',{ params:{ id } }).then(res => {
        let { code, message } = res
        if(code == 200){
          this.$message.success(message)
        } else {
          this.$message.warning(message)
        }
        this.selectall = []
        this.selectedRowKeys = []


        setTimeout(() => {
          this.httpInits()
        },800)

      })
    },
	  changePage(page){
		  this.pages = page
		  this.httpInits()
	  },
    /**
     * @name 初始页面数据
     */
    httpInits(){
      this.loading = true
      this.$request.get('?module=pc_api&action=freight&m=index&page='+this.pages).then(res => {
        let { code, data, message } = res
        if(code === 200){
        
          this.list = Array.from(data.list,item => {

            if(item.is_default === '0'){
              item['isw'] = false
            } else {
              item['isw'] = true
            }

            return item
          })
		  
		  this.total = data.total_num

          setTimeout(() => {
            this.loading = false
          },600)
        }
      })
    },
    /**
     * @name 更新当前页
     */
    httpUpdate(values){

      this.loading = true
      this.$request.get('?module=pc_api&action=freight&m=index',{ params:{ ...values, pagesize: 10 }}).then(res => {
        let { code, data, message } = res
        if(code === 200){
          this.list = Array.from(data.list,item => {
          
            if(item.is_default === '0'){
              item['isw'] = false
            } else {
              item['isw'] = true
            }
          
            return item
          })

          setTimeout(() => {
            this.loading = false
          },600)
        }
      })
    },
    /**
     * @name 取操作列表
     * @return {  }
     * */ 
    getActionList(){
      return this.columns.filter(item =>item.key === 'action')
    },
    /**
     * @name 表格操作回调
     * @return { }
     * */ 
    onCallback(callback,{ text, record }){
      callback.call(this,text,record)
    },
    /**
     * @name 操作分割线
     * @return { }
     * */ 
    isDividerShow(i,list){
      i += 1
      if(list.length){
        return i != list.length
      }
    },
    /**
     * @name 多选框选中回调
     * @return { }
     * */ 
    onSelectChange(selectedRowKeys,selectall) {
      Object.assign(this,{
        selectedRowKeys,
        selectall
      })
    },
    /**
     * @name 表格开关选择器
     * @return { }
     * */ 
    onSwitchChange(record){
      this.$request.get('?module=pc_api&action=freight&m=set_default',{ params:{ id:record.id } }).then(res => {
        let { code, message } = res

        if(code === 200){
          this.$message.success(message)
          this.httpInits()
        } else {

          this.$message.success(message)

          this.httpInits()
        }
      })
    },
    /**
     * @name 添加模版
     * @return { }
     * */ 
    onAddTemplate(){
      this.$router.push({path:'config/add?pageType=1'})
    },
    /**
     * @name 搜索重置
     */
    handleReset() {
      this.form.resetFields()
    },
    /**
     * @name 搜索表单回调
     */
    handleSearch(e) {
      e.preventDefault();
      this.form.validateFields((err, values) => {
        if (!err) {
          this.httpUpdate(values)
        }
      })
    },
    /**
     * @name 批量删除
     */
    httpBatchDelete(){
      let { selectall } = this
      let list = null

      if(selectall.length){
        this.$confirm({
          title: '提示',
          content: '确认要删除所选的模版吗？',
          okText: '确认',
          okType: 'danger',
          cancelText: '取消',
          onOk:() => {
            list = Array.from(selectall,item => item.id)
            // httpDeletes.call(this,list.join(','))
            this.httpDeletes(list.join(','))
          }
        })
        return 
      }
      this.$message.warning('请选择需删除的模版！')

    }
  }
}
</script>

<style lang="less" scoped>
.ant-spin-nested-loading .ant-table .ant-table-content{
	height: 473px;
}
.client_manage {
	background: #f0f2f5;
  .search {
    padding: 8px 10px;
	background: #ffffff;
  }
  
  .ant-table-wrapper {
	  background: #ffffff;
  }

  .handle {
    padding-bottom: unset;
    padding: 15px 0px;
    display: flex;
    align-items: center;
  }
}
</style>